import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import LinearProgress from 'material-ui/Progress';
import Button from 'material-ui/Button';

import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Divider from 'material-ui/Divider';

import Avatar from 'material-ui/Avatar';
import {Add, Place} from 'material-ui-icons';

import Editation from './Editation';

import axios from 'axios';

class LocationList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			rowsPerPage: 10,
		    page: 0,
		    total: 0,
			data: [],
			entity: {},
            formDisplay: false
		};
	}

	componentDidMount() {
		this.loadEntities(1);
	}

	loadEntities(page) {
		axios.get('/api/operator/flight/locations?page=' + page + '&perPage=' + this.state.rowsPerPage)
			.then((response) => {
				//console.log(response.data);
				this.setState({
					data: response.data.data,
					page: response.data.current_page,
					total: response.data.total,
					rowsPerPage: parseInt(response.data.per_page),
					//entity: response.data.data[0]
				});
			});
	}

	handleChangePage(e, page) {
		this.loadEntities(page+1);	// paginator counts pages as indexes (starting 0)
	}

	handleClick(model) {
		this.setState({
			entity: model,
            formDisplay: true,
		});
        // TODO: Focus to editation form
	}

    handleCloseForm = () => {
        this.setState({
            entity: null,
            formDisplay: false,
        })
    }

	saveEntity = (model) => {

		axios.post('/api/operator/flight/locations' + (model.id ? '/'+model.id : ''), model)
			.then((response) => {
                this.setState({
                    entity: {},
                    formDisplay: false
                });
                this.loadEntities(this.state.page);
			});
	}

    deleteEntity = (model) => {
        axios.delete('/api/operator/flight/locations/' + model.id )
            .then((response) => {
                this.setState({
                    entity: {},
                    formDisplay: false
                });
                this.loadEntities(this.state.page);
            });
    }

    createNew = () => {
        this.setState({
            entity: { files: [] },
            formDisplay: true
        });
        // TODO: Focus to editation form
    }

    render() {
    	return (
    	<div>
        		
    		<div style={this.state.formDisplay ? {} : {display: "none"}}>
        		<Editation 
                    ref="editationForm"
                    entityData={this.state.entity ? this.state.entity : {}} 
                    saveEntity={this.saveEntity}
                    deleteEntity={this.deleteEntity}
                    onBackBtn={this.handleCloseForm} />
    		</div>

            {this.state.formDisplay ? '' : 

            <div>
                <Button raised fab color="accent" 
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={this.createNew}
                >
                    <Add />
                </Button>

                <Paper>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            
                            <List>
                                {this.state.data.map((model, index) => {
                                    return (
                                        <div key={model.id}>
                                            <ListItem button
                                                onClick={(e) => {this.handleClick(model)}}
                                            >
                                                <Avatar style={{color: 'red', backgroundColor: 'white'}}>
                                                    <Place />
                                                </Avatar>
                                                <ListItemText className="br-break"
                                                    primary={model.name}
                                                    secondary={model.gps_lat + ', ' + model.gps_long}
                                                />
                                            </ListItem>
                                            <Divider light />
                                        </div>
                                    );
                                })}
                            </List>
                            <Table className="">
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={this.state.total}
                                            rowsPerPage={this.state.rowsPerPage}
                                            rowsPerPageOptions={[this.state.rowsPerPage]}
                                            page={this.state.page-1}
                                            onChangePage={(e, page) => {this.handleChangePage(e, page)}}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
            	</Paper>
            </div>
            
            }

        </div>
        );
    }
}

export default LocationList;


// WEBPACK FOOTER //
// ./app/used/locations/routes/List.js